<template>
    <div>
        <v-dialog
            v-model="show"
            max-width="1200px"
            max-height="90vh"
            persistent
        >
            <v-card
                style="max-height: 90vh; display: flex; flex-direction: column;"
            >
                <v-card-title class="primary white--text">
                    <v-icon left color="white">mdi-account-plus</v-icon>
                    {{
                        modoEdicao
                            ? ` Editar Login Social: ${loginSocial.nome}`
                            : 'Criar Novo Login Social'
                    }}
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="fecharModal">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text class="pa-6" style="flex: 1; overflow-y: auto;">
                    <Loading :active="loading" :is-full-page="false" />

                    <v-form ref="formLoginSocial" v-model="formValido">
                        <v-row>
                            <v-col cols="12" md="6">
                                <v-text-field
                                    v-model="dadosEdicao.nome"
                                    label="Nome *"
                                    outlined
                                    dense
                                    :rules="nomeRules"
                                    :disabled="loading"
                                    data-cy="nome"
                                ></v-text-field>
                            </v-col>

                            <v-col cols="12" md="6">
                                <v-text-field
                                    v-model="dadosEdicao.email"
                                    label="Email *"
                                    outlined
                                    dense
                                    type="email"
                                    :rules="emailRules"
                                    :disabled="loading || modoEdicao"
                                    data-cy="email"
                                ></v-text-field>
                            </v-col>

                            <v-col cols="12" md="6">
                                <v-select
                                    v-model="dadosEdicao.perfil"
                                    :items="perfilOptions"
                                    label="Perfil *"
                                    outlined
                                    dense
                                    :rules="perfilRules"
                                    :disabled="loading"
                                    data-cy="perfil"
                                ></v-select>
                            </v-col>

                            <v-col cols="12" md="6">
                                <v-row class="flex-column flex-md-row">
                                    <v-col cols="12" md="8">
                                        <v-text-field
                                            v-model="dadosEdicao.senha"
                                            label="Senha (Opcional)"
                                            outlined
                                            dense
                                            :type="
                                                showPassword
                                                    ? 'text'
                                                    : 'password'
                                            "
                                            :append-icon="
                                                showPassword
                                                    ? 'mdi-eye-off'
                                                    : 'mdi-eye'
                                            "
                                            @click:append="
                                                showPassword = !showPassword
                                            "
                                            :disabled="loading"
                                            data-cy="senha"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        md="4"
                                        class="d-flex justify-center"
                                    >
                                        <v-btn
                                            color="primary"
                                            @click="gerarSenha"
                                            :disabled="loading"
                                        >
                                            Gerar Senha
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-col>

                            <v-col cols="12">
                                <v-divider class="my-4"></v-divider>
                                <h3 class="mb-4">
                                    Associação de Apresentantes
                                </h3>

                                <v-row>
                                    <v-col cols="12" md="5">
                                        <v-card
                                            outlined
                                            style="height: 345px; display: flex; flex-direction: column;"
                                        >
                                            <v-card-title class="text-h6 py-3">
                                                Apresentantes Disponíveis
                                                <v-spacer></v-spacer>
                                                <v-chip
                                                    small
                                                    color="secondary"
                                                    >{{
                                                        apresentantesDisponiveisFiltrados.length
                                                    }}</v-chip
                                                >
                                            </v-card-title>
                                            <v-card-text class="pa-0">
                                                <v-text-field
                                                    v-model="buscarDisponivel"
                                                    label="Buscar por sigla ou nome"
                                                    outlined
                                                    dense
                                                    hide-details
                                                    prepend-inner-icon="mdi-magnify"
                                                    class="ma-3 mt-0"
                                                ></v-text-field>

                                                <v-list
                                                    dense
                                                    class="apresentantes-list"
                                                    style="flex: 1; overflow-y: auto;"
                                                >
                                                    <v-list-item
                                                        v-if="
                                                            apresentantesDisponiveisFiltrados.length ===
                                                                0
                                                        "
                                                        disabled
                                                    >
                                                        <v-list-item-content>
                                                            <v-list-item-title
                                                                class="text-center grey--text"
                                                            >
                                                                {{
                                                                    apresentantesDisponiveis.length ===
                                                                    0
                                                                        ? 'Carregando apresentantes...'
                                                                        : 'Todos os apresentantes já foram selecionados'
                                                                }}
                                                            </v-list-item-title>
                                                        </v-list-item-content>
                                                    </v-list-item>
                                                    <v-list-item
                                                        v-for="apresentante in apresentantesDisponiveisFiltrados"
                                                        :key="
                                                            apresentante.sigla
                                                        "
                                                        @click="
                                                            selecionarApresentante(
                                                                apresentante
                                                            )
                                                        "
                                                        :class="{
                                                            'v-list-item--active': apresentantesSelecionadosTemp.includes(
                                                                apresentante.sigla
                                                            )
                                                        }"
                                                    >
                                                        <v-list-item-content>
                                                            <v-list-item-title>
                                                                {{
                                                                    apresentante.sigla
                                                                }}
                                                                -
                                                                {{
                                                                    apresentante.nome
                                                                }}
                                                            </v-list-item-title>
                                                        </v-list-item-content>
                                                    </v-list-item>
                                                </v-list>
                                            </v-card-text>
                                        </v-card>
                                    </v-col>

                                    <v-col
                                        cols="12"
                                        md="2"
                                        class="d-flex flex-column justify-center align-center"
                                    >
                                        <v-btn
                                            color="primary"
                                            class="mb-2"
                                            @click="adicionarSelecionados"
                                            :disabled="
                                                apresentantesSelecionadosTemp.length ===
                                                    0
                                            "
                                        >
                                            <v-icon>mdi-arrow-right</v-icon>
                                        </v-btn>
                                        <v-btn
                                            color="secondary"
                                            @click="removerSelecionados"
                                            :disabled="
                                                apresentantesParaRemover.length ===
                                                    0
                                            "
                                        >
                                            <v-icon>mdi-arrow-left</v-icon>
                                        </v-btn>
                                    </v-col>

                                    <v-col cols="12" md="5">
                                        <v-card
                                            outlined
                                            style="height: 345px; display: flex; flex-direction: column;"
                                        >
                                            <v-card-title class="text-h6 py-3">
                                                Apresentantes Selecionados
                                                <v-spacer></v-spacer>
                                                <v-chip small color="primary">{{
                                                    dadosEdicao
                                                        .apresentantesSelecionados
                                                        .length
                                                }}</v-chip>
                                            </v-card-title>
                                            <v-card-text
                                                class="pa-0"
                                                style="flex: 1; display: flex; flex-direction: column;"
                                            >
                                                <div
                                                    class="ma-3 mb-0"
                                                    style="height: 40px; display: flex; align-items: center;"
                                                >
                                                    <span
                                                        class="text-caption grey--text"
                                                    >
                                                        Clique para selecionar
                                                        apresentantes para
                                                        remoção
                                                    </span>
                                                </div>

                                                <v-alert
                                                    v-if="
                                                        dadosEdicao
                                                            .apresentantesSelecionados
                                                            .length === 0
                                                    "
                                                    type="warning"
                                                    dense
                                                    text
                                                    class="ma-3 mt-0"
                                                >
                                                    Pelo menos um apresentante
                                                    deve ser selecionado
                                                </v-alert>

                                                <v-list
                                                    dense
                                                    class="apresentantes-list"
                                                    style="flex: 1; overflow-y: auto;"
                                                >
                                                    <v-list-item
                                                        v-for="sigla in dadosEdicao.apresentantesSelecionados"
                                                        :key="sigla"
                                                        @click="
                                                            selecionarParaRemover(
                                                                sigla
                                                            )
                                                        "
                                                        :class="{
                                                            'v-list-item--active': apresentantesParaRemover.includes(
                                                                sigla
                                                            )
                                                        }"
                                                    >
                                                        <v-list-item-content>
                                                            <v-list-item-title>
                                                                {{ sigla }} -
                                                                {{
                                                                    getNomeBySigla(
                                                                        sigla
                                                                    )
                                                                }}
                                                            </v-list-item-title>
                                                        </v-list-item-content>
                                                    </v-list-item>
                                                </v-list>
                                            </v-card-text>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>

                <v-card-actions class="pa-6">
                    <v-btn
                        color="success"
                        @click="salvarLoginSocial"
                        :loading="loading"
                        :disabled="
                            !formValido ||
                                dadosEdicao.apresentantesSelecionados.length ===
                                    0
                        "
                    >
                        <v-icon left>mdi-content-save</v-icon>
                        {{ modoEdicao ? 'Atualizar' : 'Salvar' }}
                    </v-btn>
                    <v-spacer></v-spacer>

                    <v-btn
                        style="background-color: #e74c3c; color: white;"
                        @click="salvarLoginSocial('desativar')"
                        :loading="loading"
                    >
                        <v-icon left color="white">mdi-account-remove</v-icon>
                        Desativar Login Social
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="grey"
                        text
                        @click="fecharModal"
                        :disabled="loading"
                    >
                        Cancelar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogConfirmacaoRemocao" max-width="500">
            <v-card>
                <v-card-title class="headline">
                    Confirmar Remocao
                </v-card-title>
                <v-card-text>
                    Remover este apresentante desabilitará o acesso via login
                    social. Continuar?
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="grey"
                        text
                        @click="dialogConfirmacaoRemocao = false"
                    >
                        Cancelar
                    </v-btn>
                    <v-btn color="red" @click="confirmarRemocaoApresentante">
                        Remover
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogConfirmacaoDesativacao" max-width="500">
            <v-card>
                <v-card-title class="headline red--text">
                    <v-icon left color="red">mdi-alert</v-icon>
                    Confirmar Desativação
                </v-card-title>
                <v-card-text>
                    <p class="mb-4">
                        Esta ação irá desativar permanentemente o login social e
                        remover todos os apresentantes associados.
                    </p>
                    <p class="mb-4 font-weight-bold">
                        Para confirmar, digite "desativar" no campo abaixo:
                    </p>
                    <v-text-field
                        v-model="textoConfirmacao"
                        label="Digite 'desativar' para confirmar"
                        outlined
                        dense
                        :error="
                            textoConfirmacao.length > 0 &&
                                textoConfirmacao !== 'desativar'
                        "
                        :error-messages="
                            textoConfirmacao.length > 0 &&
                            textoConfirmacao !== 'desativar'
                                ? 'Texto não confere'
                                : ''
                        "
                    ></v-text-field>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="grey" text @click="fecharModalDesativacao">
                        Cancelar
                    </v-btn>
                    <v-btn
                        color="red"
                        @click="confirmarDesativacao"
                        :disabled="textoConfirmacao !== 'desativar'"
                        :loading="loading"
                    >
                        <v-icon left>mdi-account-remove</v-icon>
                        Confirmar Desativação
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import LoginSocialService from '@/services/LoginSocialService';
import Loading from 'vue-loading-overlay';

export default {
    name: 'ModalLoginSocial',
    components: {
        Loading
    },
    props: {
        showModal: {
            type: Boolean,
            default: false
        },
        loginSocial: {
            type: Object,
            default: () => ({})
        },
        modoEdicao: {
            type: Boolean,
            default: false
        },
        apresentantesDisponiveis: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            loading: false,
            formValido: false,
            showPassword: false,
            dadosEdicao: {
                nome: '',
                email: '',
                perfil: '',
                apresentantesSelecionados: [],
                senha: ''
            },
            perfilOptions: [
                { text: 'Admin', value: 'Admin' },
                { text: 'Basic', value: 'Basic' }
            ],
            buscarDisponivel: '',
            apresentantesSelecionadosTemp: [],
            apresentantesParaRemover: [],
            dialogConfirmacaoRemocao: false,
            dialogConfirmacaoDesativacao: false,
            textoConfirmacao: '',
            apresentanteParaRemover: null,
            nomeRules: [v => !!v || 'Nome é obrigatório'],
            emailRules: [
                v => !!v || 'Email é obrigatório',
                v => /.+@.+\..+/.test(v) || 'Email deve ser válido'
            ],
            perfilRules: [v => !!v || 'Perfil é obrigatório']
        };
    },
    computed: {
        show: {
            get() {
                return this.showModal;
            },
            set(value) {
                if (!value) {
                    this.$emit('fecharModal');
                }
            }
        },
        apresentantesDisponiveisFiltrados() {
            if (
                !this.apresentantesDisponiveis ||
                this.apresentantesDisponiveis.length === 0
            ) {
                return [];
            }

            let filtrados = this.apresentantesDisponiveis.filter(
                ap =>
                    !this.dadosEdicao.apresentantesSelecionados.includes(
                        ap.sigla
                    )
            );

            if (this.buscarDisponivel) {
                const busca = this.buscarDisponivel.toLowerCase();
                filtrados = filtrados.filter(ap => {
                    const incluiBusca =
                        (ap.sigla && ap.sigla.toLowerCase().includes(busca)) ||
                        (ap.nome && ap.nome.toLowerCase().includes(busca));
                    return incluiBusca;
                });
            }

            return filtrados;
        }
    },
    watch: {
        showModal: {
            immediate: true,
            handler(novoValor) {
                if (novoValor && this.loginSocial) {
                    this.inicializarDados();
                }
            }
        },
        loginSocial: {
            immediate: true,
            deep: true,
            handler(novoValor) {
                if (novoValor && this.showModal) {
                    this.inicializarDados();
                }
            }
        },
        apresentantesDisponiveis: {
            immediate: true,
            handler(novoValor) {
                if (novoValor && novoValor.length > 0) {
                    this.$forceUpdate();
                }
            }
        }
    },
    methods: {
        inicializarDados() {
            this.dadosEdicao = {
                nome: this.loginSocial.nome || '',
                email: this.loginSocial.email || '',
                perfil: this.loginSocial.perfil || '',
                senha: this.loginSocial.senha || '',
                apresentantesSelecionados: [
                    ...(this.loginSocial.apresentantesSelecionados || [])
                ]
            };

            this.buscarDisponivel = '';
            this.apresentantesSelecionadosTemp = [];
            this.apresentantesParaRemover = [];
            this.showPassword = false;

            this.$nextTick(() => {
                if (this.$refs.formLoginSocial) {
                    this.$refs.formLoginSocial.resetValidation();
                }
            });
        },

        selecionarApresentante(apresentante) {
            const index = this.apresentantesSelecionadosTemp.indexOf(
                apresentante.sigla
            );
            if (index > -1) {
                this.apresentantesSelecionadosTemp.splice(index, 1);
            } else {
                this.apresentantesSelecionadosTemp.push(apresentante.sigla);
            }
        },

        selecionarParaRemover(sigla) {
            const index = this.apresentantesParaRemover.indexOf(sigla);
            if (index > -1) {
                this.apresentantesParaRemover.splice(index, 1);
            } else {
                this.apresentantesParaRemover.push(sigla);
            }
        },

        adicionarSelecionados() {
            this.apresentantesSelecionadosTemp.forEach(sigla => {
                if (
                    !this.dadosEdicao.apresentantesSelecionados.includes(sigla)
                ) {
                    this.dadosEdicao.apresentantesSelecionados.push(sigla);
                }
            });
            this.apresentantesSelecionadosTemp = [];
        },

        removerSelecionados() {
            if (this.apresentantesParaRemover.length > 0 && this.modoEdicao) {
                this.dialogConfirmacaoRemocao = true;
            } else {
                this.confirmarRemocaoApresentante();
            }
        },

        confirmarRemocaoApresentante() {
            this.apresentantesParaRemover.forEach(sigla => {
                const index = this.dadosEdicao.apresentantesSelecionados.indexOf(
                    sigla
                );
                if (index > -1) {
                    this.dadosEdicao.apresentantesSelecionados.splice(index, 1);
                }
            });
            this.apresentantesParaRemover = [];
            this.dialogConfirmacaoRemocao = false;
        },

        removerApresentanteIndividual(sigla) {
            if (this.modoEdicao) {
                this.apresentanteParaRemover = sigla;
                this.dialogConfirmacaoRemocao = true;
            } else {
                const index = this.dadosEdicao.apresentantesSelecionados.indexOf(
                    sigla
                );
                if (index > -1) {
                    this.dadosEdicao.apresentantesSelecionados.splice(index, 1);
                }
            }
        },

        async salvarLoginSocial(acao = null) {
            // Se ação for desativar, abre modal de confirmação
            if (acao === 'desativar') {
                this.dialogConfirmacaoDesativacao = true;
                return;
            }

            if (acao !== 'desativar') {
                if (!this.$refs.formLoginSocial.validate()) {
                    return;
                }

                if (this.dadosEdicao.apresentantesSelecionados.length === 0) {
                    this.$emit(
                        'mostrarMensagem',
                        'Pelo menos um apresentante deve ser selecionado',
                        'error'
                    );
                    return;
                }
            }

            try {
                this.loading = true;
                const service = new LoginSocialService(this.$http, this.$store);

                const dadosParaSalvar = {
                    nome: this.dadosEdicao.nome,
                    email: this.dadosEdicao.email,
                    perfil: this.dadosEdicao.perfil.toLowerCase(),
                    senha: this.dadosEdicao.senha || null,
                    apresentantes:
                        acao === 'desativar'
                            ? []
                            : this.dadosEdicao.apresentantesSelecionados,
                    user_social_id: this.loginSocial.id ?? null,
                    user_id: this.loginSocial.user_id ?? null
                };
                if (this.modoEdicao) {
                    await service.atualizarLoginSocial(
                        this.loginSocial.id,
                        dadosParaSalvar
                    );
                    this.$emit(
                        'mostrarMensagem',
                        'Login social atualizado com sucesso',
                        'success'
                    );
                } else {
                    await service.criarLoginSocial(dadosParaSalvar);
                    this.$emit(
                        'mostrarMensagem',
                        'Login social criado com sucesso',
                        'success'
                    );
                }

                this.$emit('atualizarLista');
                this.fecharModal();
            } catch (error) {
                console.error(
                    'Erro ao salvar login social:',
                    error.body.mensagem
                );

                if (error.body) {
                    if (error.body.mensagem.includes('email')) {
                        this.$emit(
                            'mostrarMensagem',
                            'Email inválido ou duplicado',
                            'error'
                        );
                    } else {
                        this.$emit(
                            'mostrarMensagem',
                            error.body.mensagem,
                            'error'
                        );
                    }
                } else {
                    this.$emit(
                        'mostrarMensagem',
                        'Erro ao salvar login social',
                        'error'
                    );
                }
            } finally {
                this.loading = false;
            }
        },

        gerarSenha() {
            const length = 9;
            const uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
            const lowercase = 'abcdefghijklmnopqrstuvwxyz';
            const digits = '0123456789';
            const special = '!@#$%^&*()_+-=[]{}|;:,.<>?';
            let password = '';
            // Ensure at least one uppercase
            password += uppercase[Math.floor(Math.random() * uppercase.length)];
            // At least one special
            password += special[Math.floor(Math.random() * special.length)];
            // Fill the rest with random chars from all
            const allChars = uppercase + lowercase + digits + special;
            for (let i = 2; i < length; i++) {
                password +=
                    allChars[Math.floor(Math.random() * allChars.length)];
            }
            // Shuffle the password to randomize positions
            this.dadosEdicao.senha = this.shuffleString(password);
        },

        shuffleString(str) {
            const arr = str.split('');
            for (let i = arr.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [arr[i], arr[j]] = [arr[j], arr[i]];
            }
            return arr.join('');
        },

        fecharModalDesativacao() {
            this.dialogConfirmacaoDesativacao = false;
            this.textoConfirmacao = '';
        },

        async confirmarDesativacao() {
            if (this.textoConfirmacao !== 'desativar') {
                return;
            }

            try {
                this.loading = true;
                const service = new LoginSocialService(this.$http, this.$store);

                const dadosParaSalvar = {
                    nome: this.dadosEdicao.nome,
                    email: this.dadosEdicao.email,
                    perfil: this.dadosEdicao.perfil.toLowerCase(),
                    senha: this.dadosEdicao.senha || null,
                    apresentantes: [],
                    user_social_id: this.loginSocial.id ?? null,
                    user_id: this.loginSocial.user_id ?? null
                };

                await service.atualizarLoginSocial(
                    this.loginSocial.id,
                    dadosParaSalvar
                );

                this.$emit(
                    'mostrarMensagem',
                    'Login social desativado com sucesso',
                    'success'
                );

                this.$emit('atualizarLista');
                this.fecharModalDesativacao();
                this.fecharModal();
            } catch (error) {
                console.error(
                    'Erro ao desativar login social:',
                    error.body?.mensagem || error.message
                );

                this.$emit(
                    'mostrarMensagem',
                    error.body?.mensagem || 'Erro ao desativar login social',
                    'error'
                );
            } finally {
                this.loading = false;
            }
        },

        fecharModal() {
            this.fecharModalDesativacao();
            this.$emit('fecharModal');
        },

        getNomeBySigla(sigla) {
            const ap = this.apresentantesDisponiveis.find(
                a => a.sigla === sigla
            );
            return ap ? ap.nome : sigla;
        }
    }
};
</script>

<style scoped>
.v-card-title {
    font-weight: 600;
}

.v-list-item--active {
    background-color: rgba(25, 118, 210, 0.12);
}

.v-list-item:hover {
    background-color: rgba(0, 0, 0, 0.04);
}

.v-card >>> .v-data-table {
    font-size: 0.875rem;
}

.v-dialog > .v-card > .v-card-text {
    max-height: 80vh;
    overflow-y: auto;
}

.v-dialog .v-card {
    max-height: 90vh !important;
}

.v-dialog .v-card .v-card-text {
    overflow-y: auto;
}

.apresentantes-list {
    max-height: 200px;
    overflow-y: auto;
}
</style>
